import { render, staticRenderFns } from "./DigitalSignUserEditComponent.vue?vue&type=template&id=2646a50c"
import script from "./DigitalSignUserEditComponent.vue?vue&type=script&lang=js"
export * from "./DigitalSignUserEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports